(function(EF) {
  var CourseSettingsService = require('services/course-settings-service');
  var utils = require('lib/utils');

  var LocationsCollection = Chaplin.Collection.extend({
    model: EF.Models.Location,
    comparator: 'id',

    initialize(options) {
      if(options && options.localData) {
        this.data = options.localData;
      }
      Chaplin.Collection.prototype.initialize.apply(this, arguments);
    },

    fetch() {
      if(CourseSettingsService.get('local')) {
        return new Promise((resolve) => {
          var localData = this.data || utils.tryRequire('local-data/locations.json');
          this.set(utils.sanifyJsonApiObject(localData.data, localData.included).map(l => new EF.Models.Location(l)));
          return resolve(this);
        });
      } else {
        return fetch(`${CourseSettingsService.get('portalBasePath')}/locations.json`, {
          headers: { 'Authorization': `Bearer ${EF.config.get('jwt')}`, 'Accept': 'application/json' },
          credentials: 'include' }
        ).then(response => response.json())
         .then(response => {
           this.set(utils.sanifyJsonApiObject(response.data, response.included).map(l => new EF.Models.Location(l)));
           return Promise.resolve(this);
        });
      }
    }
  });

  _.extend(EF.Collections, {
    LocationsCollection: LocationsCollection
  });
})(window.EF);
